import { useQuery } from "@tanstack/react-query";
import { hubMutations } from "@surgia/api/src/queryStore/hub";
import { PurchaseRequestListingItem } from "../../../../../packages/contract/dtos/purchaseRequest";

export const useGetPurchaseRequestListings = (params: {
  componentId: string;
  tenantId: string;
  branchesIds: string;
  status?: "SUBMITTED" | "ORDERED" | "DRAFT";
  page?: number;
  size?: number;
  sort?: string;
  has_purchase_order?: boolean;
}) => {
  return useQuery({
    ...hubMutations.purchaseRequest.queries.getListings(params),
    // enabled: !!params.componentId && !!params.tenantId && !!params.branchesIds,
    select: (data: { total: number; data: PurchaseRequestListingItem[] }) => ({
      total: data?.total || 0,
      data: data?.data?.map((item) => ({
        id: item.id,
        requestedBy: item.created_by,
        branch: item.branch.name,
        quantity: item.total_quantity,
        totalPrice: item?.purchase_request_price?.price,
        dateCreated: item.created_at,
        status: item.status,
        originalData: item,
        branchId: item.branch.id,
      })) || [],
    }),
  });
};